import styled from 'styled-components';
import { StyledEntityItem } from 'components/Global/EntityItem/styled.js';

export const TileContentContainer = styled.div`
  width: 100%;
  padding: 30px 40px;
  margin: 35px auto 0 auto;
`;

export const HubLabel = styled.div`
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ContentCountLabel = styled.div`
  max-width: 100%;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BoxedFillBarContainer = styled.div`
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  position: relative;
  margin-bottom: 5px;
  width: 100%;
  padding: 23px;
  text-align: left;
  white-space: nowrap;
  

  ${StyledEntityItem} {
    color: #3A4049;
    text-transform: capitalize;
    vertical-align: bottom;
  }
`;
